type VersionInfo = {
  version: string;
  build: string;
};

const versionInfo: VersionInfo = require('../../version.json');

export default versionInfo;
